import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0153139d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0153139d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0153139d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0153139d')) {
      api.createRecord('0153139d', component.options)
    } else {
      api.reload('0153139d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0153139d&scoped=true&", function () {
      api.rerender('0153139d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/battleRoyale/index.vue"
export default component.exports